// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** getSchemeTypes  */
interface ISchemeTypesOutput {
  applicant_type_id: number;
  code: 'EU' | 'NON_EU' | 'IOSS';
  description: string;
}

export const getSchemeTypes = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/schemeType`
  );

  let _data: ISchemeTypesOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** getCountries  */
interface IGetCountriesOutput {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const getAllCountries = async (): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country`
  );

  let _data: IGetCountriesOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const getCountriesNotInStateMember = async (
  includeCountries?: string
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/country/non-member-state${
      includeCountries ? `?includeCountries=${includeCountries}` : ''
    }`
  );

  let _data: IGetCountriesOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export const getCountriesExludeCyprus =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/country/exclude?countries=CY`
    );

    let _data: IGetCountriesOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };

export const getCountriesMemberStateExcludeCyprus =
  async (): Promise<Types.ResponseOutput> => {
    const { data }: any = await request(
      'get',
      `${Environment.API_BASE_URL}/api/country/member-state?excludeCyprus=true`
    );

    let _data: IGetCountriesOutput = data.data;
    let output: Types.ResponseOutput = {
      message: data.message,
      data: _data,
      status: data.status,
    };
    return output;
  };

/** registerUser  */
interface IRegisterUserInput {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const registerUser = async (
  payload: IRegisterUserInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/oauth/register`,
    payload
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: null,
    status: data.status,
  };
  return output;
};
